<div  class="display-step-two row product-detail-row">
    <div class="col-md-1 col-sm-0"></div>
    <div class="col-md-10">
      <div class="row">
        <app-details-cube
          class="col-md-4"
        ></app-details-cube>
        <div class="col-md-7 order-details-wrapper product-detail-row">
          <div class="user-details">
            <div class="row comment-wrapper">
              <div class="col-md-12 more-detail-box">
                <div class="order-details-title">
                  <label
                    for="user-name"
                    class="title-label aditional-data-title"
                    >פירוט הבקשה</label
                  >
                </div>

                <div class="form-group col-md-12">
                  <div class="aditional-data-lbl">
                    <div class="additional-details-title">
                      שים לב, בפירוט הבקשה חשוב להתייחס לדברים הבאים, במידה
                      ורלוונטי:
                    </div>
                    <app-questions
                      [questions]="
                      pUiService.productView.ProductOptionItems[pUiService.currentOptionIndex]
                          .QuestionsItems
                      "
                      (userAnswerChange)="userAnswerChange($event)"
                    ></app-questions>

                    <div
                      [innerHTML]="pUiService.productView.ProductItem.AdditionalData"
                    ></div>
                  </div>
                  <textarea
                    rows="5"
                    (focus)="fieldFocus()"
                    (blur)="fieldBlur()"
                    class="form-control valid-focus special-font"
                    id="user-comment"
                    [formControl]="pUiService.userComment"
                    placeholder="רישמו הערות נוספות שאתם רוצים שנדע"
                  ></textarea>
                  <div
                    for="user-name"
                    *ngIf="pUiService.testFields[1]"
                    class="alert-danger"
                  >
                    יש למלא פירוט לבקשה
                  </div>
                </div>
              </div>

              <div class="col-md-12 scroll-input">
                <div class="form-group col-md-12" id="file-list-frame">
                  <label for="file-list" class="title-label">
                    צרף קבצים
                    <br />
                    <span class="file-list-comment">
                      (עד {{ pUiService.maxFileSize / 1000000 }} מ"ב לקובץ. סוגי קבצים
                      מותרים:
                      <span *ngFor="let fileExt of pUiService.allowedFileTYpes"
                        >{{ fileExt }}
                      </span>
                      )
                    </span>
                  </label>
                  <div
                    class="select-file pay-btn valid-focus"
                    (click)="selectFile()"
                  >
                    בחר קבצים
                  </div>

                  <input
                    *ngIf="renderFileUpload"
                    type="file"
                    id="file-list"
                    multiple
                    value="pUiService.files"
                    (change)="upload($event)"
                    placeholder="העלה קובץ"
                  />

                  <div class="col-md-12">
                    <div class="pic-list-wrapper can-droped-area">
                      <div
                        class="drop-files-test can-droped-area"
                        *ngIf="pUiService.files == null || pUiService.files.length == 0"
                      >
                        אפשר גם לגרור את הקבצים לכאן
                      </div>
                      <div
                        class="pic-list can-droped-area"
                        *ngFor="let file of pUiService.files; let fileIndex = index"
                      >
                        <div
                          class="remove-pic remove-file-item can-droped-area"
                          (click)="removeFile(fileIndex)"
                        >
                          X
                        </div>

                        <div class="detail-text-images can-droped-area">
                          <div class="file-img-wrapper can-droped-area">
                            <div class="file-img can-droped-area">
                              <img
                                class="can-droped-area"
                                *ngIf="
                                pUiService.filesSrcBase64[fileIndex] != 'dwg' &&
                                pUiService.filesSrcBase64[fileIndex] != 'pdf' &&
                                pUiService.filesSrcBase64[fileIndex] != 'zip' &&
                                pUiService.filesSrcBase64[fileIndex] != 'rar'
                                "
                                src="{{ pUiService.filesSrcBase64[fileIndex] }}"
                              />
                              <div
                                class="dwg-pic can-droped-area"
                                *ngIf="pUiService.filesSrcBase64[fileIndex] == 'dwg'"
                              ></div>
                              <div
                                class="pdf-pic can-droped-area"
                                *ngIf="
                                pUiService.filesSrcBase64[fileIndex] == 'pdf' ||
                                pUiService.filesSrcBase64[fileIndex] == 'zip' ||
                                pUiService.filesSrcBase64[fileIndex] == 'rar'
                                "
                              >
                                <fa-icon
                                  [icon]="['far', 'file-pdf']"
                                  class="can-droped-area"
                                ></fa-icon>
                              </div>
                            </div>

                            <div class="img-caption can-droped-area">
                              {{ file.name }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    for="file-list"
                    *ngIf="pUiService.testFields[2]"
                    class="alert-danger file-error"
                  >
                    {{ pUiService.errorMsg }}
                  </div>
                </div>
              </div>
            </div>

            <div class="row user-details-wrapper-box">
              <div class="col-md-12">
                <div class="pay-btn-wrapper">
                  <div class="pay-btn-new" (click)="navToProductList()">
                    הוסף לסל והזמן תוכנית נוספת
                  </div>

                  <div class="pay-or">או</div>
                  <div class="pay-btn-new" (click)="GoToBasket()">
                    המשך לתשלום
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>